import { translates } from '@/utils';
import * as yup from 'yup';

export const discountSchema = yup.object({
  ordersDetails: yup.array().of(
    yup.object({
      quantity_discount: yup
        .number()
        .max(yup.ref('quantity'), translates.formMessageMaxProductQuantity)
        .min(0, translates.formMessagePositiveNumber),

      discount: yup
        .number()
        .typeError(translates.formMessageNumberType)
        .min(0, translates.formMessagePositiveNumber)
        .max(100, translates.formMessageMaxDiscountPercentage),
    })
  ),
});
